export default __webpack_public_path__ + "static/media/alert001.529cc3d0.png";